import React, { useState } from "react";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import "../lib/DatePickerOveride.css";
import styled from "styled-components";
import {
  Text,
  Card,
  Spacer,
  Table,
  Th,
  Tr,
  TextField,
  Td,
  theme,
} from "equiratings-components";

const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: baseline;
`;

const NoData = styled.div`
  background: ${theme.colors.white};
  width: 100%;
  display: flex;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
  border-radius: ${theme.spacing.x2}
  padding: ${theme.spacing.x6};
  overflow-x: auto;
`;

const CardWithBorder = styled.div`
  border: 2px solid rgba(26, 56, 82, 0.5);
  background: ${theme.colors.white};
  width: 100%;
  display: flex;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
  border-radius: ${theme.spacing.x2};
  overflow-x: auto;
`;

const CPRByDate = ({ rows, fetchData, setDate, dateRange }) => {
  const [dateFocus, setFocus] = useState(null);
  const [horseSearch, setHorseSearch] = useState("");
  const [selectedCPR, setSelectedCPR] = useState(undefined);

  let newArr =
    horseSearch && rows && rows.length > 0
      ? rows.filter((item) =>
        item.attributes.horse
          .toLowerCase()
          .includes(horseSearch.toLowerCase())
      )
      : rows;

  return (
    newArr && (
      <>
        <>
          <TitleContainer>
            <Text
              tag="h1"
              size={[theme.fontScale.x4]}
              weight={theme.fontWeights.bold}
              lineHeight={theme.lineHeights.heading}
            >
              All CPR
            </Text>
            <div
              style={{ display: "flex", width: "60%", alginSelf: "flex-end" }}
            >
              <TextField
                placeholder={"Enter Horse name here"}
                style={{ background: theme.colors.white, border: "none" }}
                onChange={(e) => setHorseSearch(e.target.value)}
              />
              <Spacer size={theme.spacing.x3} />
              <DateRangePicker
                startDate={dateRange.startDate}
                startDateId="your_unique_start_date_id"
                endDate={dateRange.endDate}
                endDateId="your_unique_end_date_id"
                onDatesChange={({ startDate, endDate }) => {
                  setDate({ startDate, endDate });
                }}
                minimumNights={0}
                focusedInput={dateFocus}
                isOutsideRange={() => false}
                hideKeyboardShortcutsPanel={true}
                displayFormat="YYYY-MM-DD"
                onFocusChange={(focusedInput) => setFocus(focusedInput)}
              />
            </div>
          </TitleContainer>
          <Spacer size={theme.spacing.x4} />
          <div style={{ width: "100%", maxHeight: 500, overflow: "scroll" }}>
            <Card>
              <Table>
                <tbody>
                  <tr>
                    <Th>Horse</Th>
                    <Th>Athlete</Th>
                    <Th>CPR Show</Th>
                    <Th>CPR Date</Th>
                    <Th>Class</Th>
                    <Th>CPR Trigger</Th>
                    <Th>CPR Active</Th>
                  </tr>
                  {newArr.map((row, index) => {
                    return (
                      <Tr
                        key={index}
                        style={{ borderTop: "none" }}
                        onClick={() =>
                          setSelectedCPR(
                            row.attributes.cpr_contributing_results
                          )
                        }
                      >
                        <Td>
                          <a
                            href={row.attributes.horse_url}
                            style={{
                              textDecoration: "none",
                              fontWeight: theme.fontWeights.bold,
                              color: "inherit",
                            }}
                          >
                            {row.attributes.horse}
                          </a>
                        </Td>
                        <Td>
                          {row.attributes.cpr_contributing_results[0].rider}
                        </Td>
                        <Td>{row.attributes.cpr_show}</Td>
                        <Td>{row.attributes.cpr_show_date}</Td>
                        <Td>{row.attributes.cpr_class}</Td>
                        <Td>{row.attributes.cpr_trigger}</Td>
                        <Td>{row.attributes.cpr_active ? "Yes" : "No"}</Td>
                      </Tr>
                    );
                  })}
                </tbody>
              </Table>
            </Card>
          </div>
          {newArr && newArr.length > 0 ? null : (
            <NoData>
              <Text
                tag="h1"
                size={[theme.fontScale.x4]}
                weight={theme.fontWeights.normal}
                lineHeight={theme.lineHeights.heading}
                style={{
                  margin: "0 auto",
                }}
              >
                Uh oh, it looks like no data was returned, change your search
                paramaters and try again.
              </Text>
            </NoData>
          )}
        </>
        <>
          {selectedCPR ? (
            <div
              style={{
                margin: "auto",
                position: "absolute",
                width: "90%",
                top: "35%",
                left: 0,
                bottom: 0,
                right: 0,
              }}
            >
              <CardWithBorder>
                <div style={{ padding: "2%", width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Text
                      width="20%"
                      tag="h1"
                      size={[theme.fontScale.x4]}
                      weight={theme.fontWeights.bold}
                      lineHeight={theme.lineHeights.heading}
                    >
                      Contributing Results
                    </Text>
                    <Text
                      onClick={() => setSelectedCPR(undefined)}
                      width="20%"
                      tag="h1"
                      cursor="pointer"
                      size={[theme.fontScale.x4]}
                      weight={theme.fontWeights.bold}
                      lineHeight={theme.lineHeights.heading}
                    >
                      X
                    </Text>
                  </div>
                  <Spacer size={theme.spacing.x3} />
                  <Table>
                    <tbody>
                      <tr>
                        <Th>Athlete</Th>
                        <Th>Show</Th>
                        <Th>Date</Th>
                        <Th>Class</Th>
                        <Th>XC Status</Th>
                      </tr>
                      {selectedCPR.map((item, index) => {
                        return (
                          <Tr key={index}>
                            <Td>{item.rider}</Td>
                            <Td>{item.show}</Td>
                            <Td>{item.date}</Td>
                            <Td>{item.class}</Td>
                            <Td>{item.xc_status}</Td>
                          </Tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </CardWithBorder>
            </div>
          ) : null}
        </>
      </>
    )
  );
};

export default CPRByDate;
